

import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { AudienciaService } from '@services/audiencia/audiencia.service';
import { AudienciaDto } from '@models/audiencia/audienciaDto.model';
import { DialogFormAuditoriaComponent } from '../dialog-form-auditoria/dialog-form-auditoria.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { A11yModule } from '@angular/cdk/a11y';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { EstadoAudienciaService } from '@services/estadoAudiencia/estadoAudiencia.service';
import { TipoAudienciaService } from '@services/tipoAudiencia/tipoAudiencia.service';
import { AudienciaFilter } from '@models/audiencia/audienciaFilter.model';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { BaseDto } from '@models/base/baseDto.model';


@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule, AvatarInicialesComponent, BuscarExpedienteComponent, ButtonFilterTableClearComponent],
  selector: 'app-list-audiencia',
  templateUrl: './list-audiencia.component.html',
  styleUrls: ['./list-audiencia.component.css']
})



export class ListAudienciaComponent {

  accionesDialog = AccionesDialog;
  @Input() idExpediente!: number
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<AudienciaDto>();
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  checkedFiltroAvanzado: boolean = false;
  tiposAudiencia!: BaseDto[];
  estadosAudiencia!: BaseDto[];
  expedienteDto: any;
@ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }
  constructor(
    private audienciaService: AudienciaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private tipoAudienciaService: TipoAudienciaService,
    private estadoAudienciaService: EstadoAudienciaService,
  ) {

    this.formFilter = this.formBuilder.group({
      Sala: [null],
      Lugar: [null],
      FechaDesde: [null],
      FechaHasta: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      IdsTipoAudiencia: [null],
      IdsEstadoAudiencia: [null],
      Notificado: [null],
      LinkVirtual: [null],
      RequiereActa: [null],
      ActaGenerada: [null],
      ActaUrl: [null],
      AsignadoA: [null],
      IdExpediente: [null],
    });
     this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  guardarFiltro() {
    const filtro: AudienciaFilter = this.formFilter.value;
    localStorage.setItem('filtroAuditoriaGuardado', JSON.stringify(filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroAuditoriaGuardado');
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit(): void {

    this.getAllTiposAudiencia();
    this.getAllEstadosAudiencia();

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      if (this.idExpediente) {
        this.displayedColumns = result.matches ?
          ['lugar', 'asignadoA', 'accion'] :
          ['lugar', 'sala', 'fecha', 'tipoAudiencia', 'estadoAudiencia', 'asignadoA', 'estados', 'accion'];
        this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
        this.getAllAudienciasByIdExpediente(this.idExpediente);
      } else {
        this.displayedColumns = result.matches ?
          ['lugar', 'asignadoA', 'accion'] :
          ['lugar', 'sala', 'fecha', 'tipoAudiencia', 'estadoAudiencia', 'asignadoA', 'estados', 'accion'];

      }
    });

    const filtroAuditoriaGuardado = localStorage.getItem('filtroAuditoriaGuardado');
    if (filtroAuditoriaGuardado) {
      const filtro: AudienciaFilter = JSON.parse(filtroAuditoriaGuardado);
      this.formFilter.patchValue(filtro);
    }

    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'fecha':
          return item.fecha ?? ''; // Maneja null/undefined

        case 'lugar':
          return item.lugar?.toLowerCase?.() ?? '';

        case 'sala':
          return item.sala?.toLowerCase?.() ?? '';

        case 'estadoAudiencia':
          return item.estadoAudiencia?.descripcion?.toLowerCase?.() ?? '';

        case 'tipoAudiencia':
          return item.tipoAudiencia?.descripcion?.toLowerCase?.() ?? '';

        case 'asignadoA':
          return item.asignadoA?.nombre?.toLowerCase?.() ?? '';

        default:
          return typeof item[property] === 'string'
            ? item[property].toLowerCase()
            : item[property] ?? '';
      }
    };

     this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  getAllTiposAudiencia() {
    this.spinner.show("spTiposAudiencia")
    this.tipoAudienciaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposAudiencia")
          this.tiposAudiencia = data
        },
        error => {
          this.spinner.hide("spTiposAudiencia")
          this.snackBar.showError(error, "Error");
        })
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.idExpediente = this.expedienteDto.id
    this.formFilter.controls['IdExpediente'].setValue(this.expedienteDto.id);
  }

  getAllEstadosAudiencia() {
    this.spinner.show("spEstadosAudiencia")
    this.estadoAudienciaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosAudiencia")
          this.estadosAudiencia = data
        },
        error => {
          this.spinner.hide("spEstadosAudiencia")
          this.snackBar.showError(error, "Error");
        })
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro(filtro: AudienciaFilter = this.formFilter.value) {

    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }


  getAllAudiencias() {
    this.spinner.show('spAudiencia')
    this.audienciaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spAudiencia')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spAudiencia')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllByFilter(filtro: AudienciaFilter) {
    this.spinner.show('spAudiencia')
    this.audienciaService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spAudiencia')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spAudiencia')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllAudienciasByIdExpediente(idExpediente: number) {
    this.spinner.show('spAudiencia')
    this.audienciaService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide('spAudiencia')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spAudiencia')
          this.snackBar.showError(error, "Error");
        })
  }


  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
        case AccionesDialog.Ver:
          dialogConfig.width = "70%"
          break;

        default:
          dialogConfig.width = "50%"
          break;
      }

    const dialogRef = this.dialog.open(DialogFormAuditoriaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
